// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hoS4","colBig":"styles_colBig__3VQwZ","colSmall":"styles_colSmall__3rUoP"};